// extracted by mini-css-extract-plugin
module.exports = {"sitewideAlertBanner":"az_Csc","sitewideAlertBannerIconWrapper":"az_Dsc","sitewideAlertBannerIcon":"az_Esc","sitewideAlertBannerText":"az_Fsc"};